import {
  buildDriverPortalRedirectUrl,
  shouldRedirectToDriverPortal,
} from 'app/pages/Login/utils/loginPermissions';
import { Permission } from 'app/services/api/models/Permission';
import { resolveAppPath } from 'app/utils/app-path';

function getSsoAccessToken(): string | null {
  try {
    return (
      window.sessionStorage.getItem('authToken') ||
      window.localStorage.getItem('token') ||
      null
    );
  } catch {
    return null;
  }
}

type MyUserResponse = {
  permissions?: Permission[];
};

/**
 * Before React mounts: if SSO Bearer token belongs to a driver-only user,
 * navigate to the driver portal and skip rendering the admin app entirely.
 *
 * @returns true when a redirect was started (caller must not mount React).
 */
export async function redirectDriverPortalIfNeeded(): Promise<boolean> {
  const token = getSsoAccessToken();
  if (!token) {
    return false;
  }

  try {
    const response = await fetch(resolveAppPath('/api/v2/myUser'), {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) {
      return false;
    }

    const myUser = (await response.json()) as MyUserResponse;
    if (!shouldRedirectToDriverPortal(myUser.permissions ?? [])) {
      return false;
    }

    window.location.replace(buildDriverPortalRedirectUrl());
    return true;
  } catch {
    return false;
  }
}
